/*jshint esversion: 9 */
/*jshint sub:true*/
import { mapGetters, mapActions, mapState } from 'vuex';

//draco import
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';
//raycast
import {
  acceleratedRaycast,
  computeBoundsTree,
  disposeBoundsTree,
  // CONTAINED,
  // INTERSECTED,
  // NOT_INTERSECTED,
} from 'three-mesh-bvh';

// import { ConvexGeometry } from 'three/examples/jsm/geometries/ConvexGeometry.js';

import {
AmbientLight,
AxesHelper,
Color,
DirectionalLight,
GridHelper,
PerspectiveCamera,
Scene,
WebGLRenderer,
//plan test
// SphereGeometry,
DoubleSide,
Mesh,
Vector2,
// Shape,
// ExtrudeGeometry,
Raycaster,
BufferGeometry,
Group,

MeshLambertMaterial,

BufferAttribute,
//fpv test
} from "three";

import * as THREE from 'three';

import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";

import { IfcDisplayMixin } from '@/mixins/IfcDisplay.mixin.js';
import { IfcDrawingMixin } from '@/mixins/IfcDrawing.mixin.js';
import { IfcPlansMixin } from '@/mixins/IfcPlans.mixin.js';
import { IfcRayCastingMixin } from '@/mixins/IfcRayCasting.mixin.js';
import { IfcGeometryMixin } from '@/mixins/IfcGeometry.mixin.js';
import { IfcSectionsMixin } from '@/mixins/IfcSections.mixin.js';

// import { log10 } from 'mathjs';

export const IfcInitializeMixin = {
  mixins: [
    IfcRayCastingMixin,
    IfcPlansMixin,
    IfcDrawingMixin,
    IfcDisplayMixin,
    IfcGeometryMixin,
    IfcSectionsMixin,
  ],
  components: {
  },
  data: () => ({
    camera_type: '3D',
    renderer: '',
    scene: '',
    size: '',
    camera: '',
    model: {},
    ifcLoader: '',
    controls: { enableRotate: false },
    count: 0,
    count_done: 0,
    plan: false,
    elements_by_takting_id: {},
    edges_elements_by_takting_id: {},
    edges_helper_elements_by_takting_id: {},
    // raycasting
    index_count_by_takting_id: {},
    selection_mode: 'intersects', //intersects || contains
    contains_threshold: 1,
    ctrl_key_down: false,

    highlight_material: {},
    transparent_material: {},
    points_material: {},
    shape_material: {},
    drawing: false,
    drawing_plane: {},
    drawing_cursor: {},
    drawing_object: {
      // lower_level: 0,
      // height: 2,
      // path: [
      //   {x: 0, y: 0},
      //   {x: 1, y: 0},
      //   {x: 1, y: 1},
      //   {x: 0, y: 1},
      // ],
      // shape: {},
      // material: {},
    },
    selected_shape_train_id: -1,
    selected_shape_taktarea_id: -1,
    //center model
    center_model: false,
    center_position: {x: 0, y: 0, z: 0},
    //visibility handling
    active_element_ids: [],
    show_invisible: false,
    hide_non_selected: false,
    show_elements_by_takt: false,
    show_edges: false,
    show_edges_only: false,
    show_orbit_target: true,
    //fpv test
    projection_type: '3D',
    is_fpv: false,
    clock: {},
    player: {},
    other_players: {},
    playerIsOnGround: false,
    playerVelocity: {},
    upVector: {},
    tempVector: {},
    tempVector2: {},
    tempBox: {},
    tempMat: {},
    tempSegment: {},
    fwdPressed: false,
    bkdPressed: false,
    rgtPressed: false,
    lftPressed: false,
    collider: {},
    fpv_params: {
      firstPerson: false,
      displayCollider: false,
      displayBVH: false,
      visualizeDepth: 10,
      gravity: - 30,
      playerSpeed: 10,
      physicsSteps: 5,
      reset: {},
    },
    model_is_loading: false,
    model_loading_percantage: 0,

    //IFC Drawing
        //cursor
        cursor: {
          show: false,
        },
        cursor_sphere: {}, //mesh
        handle_sphere: {}, //mesh
        //generic movings point
        moving_point: false,
        zero_plane: {}, //plane
        fixed_z_plane: {},
        fixed_z_value: 0,
        use_fixed_z: false,

        edit_geometry_object: {id: -1},
        raycast_object_name_cache: "",

        edit_geom_point_index: -1,

        edit_geom_mesh: {},
        edit_geom: {},
        edit_unstaged_geometry: {},
        edit_geom_point_cache: {x: 0, y: 0},
        create_geom_mode: false,
    
    // IFC Raycasting
        intersected_id: -1,
        intersected_name: "",
        intersected_face: {},
        mouse: {},
        raycaster: {},
        moved: false,
        raycast_object: '',
        window_mouse_down: false,

        magnetic_corner_test: false,
        use_magnetic_points: true,
      // initialze meshes
      mesh_names: [],
      edges_mesh_names: [],
      all_groups: {},
      all_normal_groups: {},
      visible_normal_group: {},
      selected_normal_group: {},
      highlighted_normal_group: {},

      // colored edges
      all_edges_groups: {},
      visible_edges_group: {},
      selected_edges_group: {},
      taktarea_elements_edges_group: {},
      step_elements_edges_group: {},
      highlighted_edges_group: {},

      transparent_group: {},
      plans_group: {},
      points_helper_group: {},
      edges_helper_group: {},

      // clipping caps
      // stencilPlaneGroup: {},
      stencilWriteMeshes: [],
  
      //unstaged visibility
      edges_unstaged_ids: [],
      visible_unstaged_ids: [],
      selected_unstaged_ids: [],
      highlighted_unstaged_ids: [],

      // clipping
      clipping_planes: [],
      clipping_plane_hor: {},
      clipping_plane_ver_x: {},
      clipping_plane_ver_y: {},
      show_section_ver_x: false,
      show_section_ver_y: false,
      show_section_hor: false,
      invert_section_ver_x: false,
      invert_section_ver_y: false,
      invert_section_hor: false,

      // mouse shape selection
      startX: - Infinity,
      startY: - Infinity,
    
      prevX: - Infinity,
      prevY: - Infinity,

      tempVec0: new THREE.Vector2(),
      tempVec1: new THREE.Vector2(),
      tempVec2: new THREE.Vector2(),

      selectionPoints: [],
      shape_selection_dragging: false,
      selectionShapeNeedsUpdate: false,
      selectionNeedsUpdate: false,
      selectionShape: {},
      shape_selection_mode: 'box',
      shape_selection_live_update: false,
  }),

  computed: {
    ...mapGetters('ProjectStructure', [
      'getIFCItems',
      'getAllChildElements',
    ]),
    ...mapGetters('ProjectCalendar', [
      'getCurrentTaktIndex'
    ]),
    ...mapGetters('Auth', [
      'getUserLiveSync',
    ]),
    ...mapGetters('Project', [
      'getProjectLength'
    ]),
    ...mapState('ProjectStructure', [
      'visible_elements',
      'visible_taktareashapes'
    ]),
  },
  methods: {
    ...mapActions('ProjectStructure', [
      'importIFC',
      'requestChildrenIds',
      'setCollectionObjects',
      'requestElementsByTakt',
      'showElementsByTakt',
      'uploadPlan',
      'removePlanFromParent',
      'parseBlobGeometry'
    ]),
    ...mapActions('Project', [
      'addUnstagedElementId',
      'removeUnstagedElementId',
    ]),
    initializeScene() {
      THREE.Object3D.DefaultUp = new THREE.Vector3(0,0,1);
      this.model_is_loading = true;
      //init center model
      this.center_position = new THREE.Vector3();

      this.highlight_material = new MeshLambertMaterial({
        color: 0xff0000,
        side: DoubleSide,
        clippingPlanes: this.clipping_planes,
        
        stencilWrite: true,
				stencilFail: THREE.IncrementWrapStencilOp,
				stencilZFail: THREE.IncrementWrapStencilOp,
				stencilZPass: THREE.IncrementWrapStencilOp,
      });
      this.highlight_material_edges = new THREE.LineBasicMaterial( { 
        color: 0xff0000,
        clippingPlanes: this.clipping_planes,
      } )
      this.element_selection_material = new THREE.LineBasicMaterial( { 
        color: 0xFF9900,
        clippingPlanes: this.clipping_planes,
      } )
      // edges materials
      this.edges_materials = {};
      this.edges_materials.selected = new THREE.LineBasicMaterial( { 
        color: 0xff0000, //red
        clippingPlanes: this.clipping_planes,
      } )
      this.edges_materials.highlighted = new THREE.LineBasicMaterial( { 
        color: 0xff0000, //red
        clippingPlanes: this.clipping_planes,
      } )
      this.edges_materials.element_selection = new THREE.LineBasicMaterial( { 
        color: 0xFF9900, //orange
        clippingPlanes: this.clipping_planes,
      } )
      this.edges_materials.step_elements = new THREE.LineBasicMaterial( { 
        color: 0x009688, //teal
        clippingPlanes: this.clipping_planes,
      } )
      this.edges_materials.taktarea_elements = new THREE.LineBasicMaterial( { 
        color: 0xE91E63, //pink
        clippingPlanes: this.clipping_planes,
      } )

      this.points_material = new THREE.PointsMaterial( { size: 5, color: 0x888888 } );
      this.transparent_material = new MeshLambertMaterial({color: new Color('white')});
      this.transparent_material.opacity = 0.15;
      this.transparent_material.transparent = true;

      this.shape_material = new MeshLambertMaterial({
        color: 0x2196F3, //blue
        side: DoubleSide,
        opacity: 0.2,
        transparent: true
      });
      this.shape_material_edit = new MeshLambertMaterial({
        color: 0xff0000, //red
        side: DoubleSide,
        opacity: 0.2,
        transparent: true, 
        depthTest: false, //always on top
      });

      BufferGeometry.prototype.computeBoundsTree = computeBoundsTree;
      BufferGeometry.prototype.disposeBoundsTree = disposeBoundsTree;
      Mesh.prototype.raycast = acceleratedRaycast;
      // THREE.LineSegments.prototype.raycast = acceleratedRaycast;

      //Creates the Three.js scene
      this.scene = new Scene();
      // this.scene.background = new Color(0xaaaaaa);
      // document.getElementById('canvas').appendChild(renderer.domElement);

      //Object to store the size of the viewport
      // let content_el = document.getElementById("ttabs-buildingmodel-content");
      let content_el = document.getElementById("project-structure-frame-background");
      this.size = {
        width: content_el.clientWidth,
        height: content_el.clientHeight,
      };
      // //Creates the camera (point of view of the user)
      this.camera = new PerspectiveCamera(75, this.size.width / this.size.height);
      this.camera.position.set(0, 0, 1);
      this.camera.updateProjectionMatrix();
      this.camera.up.set(0,0,1);
      this.camera.name = 'camera';
      this.scene.add( this.camera );

      // mouse selection shape
      this.selectionShape = new THREE.Line();
      this.selectionShape.material.color.set( 0xff9800 ).convertSRGBToLinear();
      this.selectionShape.renderOrder = 1;
      this.selectionShape.position.z = - .2;
      this.selectionShape.depthTest = false;
      this.selectionShape.scale.setScalar( 1 );
      this.selectionShape.name = "selectionShape";
      this.camera.add( this.selectionShape );


      //Creates the lights of the scene
      const lightColor = 0xffffff;

      const ambientLight = new AmbientLight(lightColor, 0.5);
      this.scene.add(ambientLight);

      const directionalLight = new DirectionalLight(lightColor, 1);
      directionalLight.position.set(0, 0, 10);
      directionalLight.target.position.set(-5, 0, 0);
      this.scene.add(directionalLight);
      this.scene.add(directionalLight.target);

      //Sets up the renderer, fetching the canvas of the HTML
      const threeCanvas = document.getElementById("three-canvas");
      threeCanvas.tabindex = 0;
      threeCanvas.focus();
      this.renderer = new WebGLRenderer({ canvas: threeCanvas, antialias: true, alpha: true });
      this.renderer.setSize(this.size.width, this.size.height);
      this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

      // clipping
      this.renderer.localClippingEnabled = true;
      // end clipping

      // create test ta element
      // let ta_geom = new BoxGeometry( 5, 5, 5 );
      // ta_geom.translate(2,8,0);
      // ta_geom.computeBoundsTree();
      // let ta_mat = new MeshLambertMaterial({color: 'blue'});
      // let ta_mesh = new Mesh(ta_geom, ta_mat);
      // ta_mesh.name = 'ta_mesh';
      // this.scene.add(ta_mesh);

      // let plane_mat = new MeshLambertMaterial({color: new Color('red'), side: DoubleSide, transparent: true, opacity: 0.3});
      // let plane = new Mesh (plane_geom, plane_mat);

      // this.scene.add(plane);

      //Creates grids and axes in the scene
      const grid = new GridHelper(10, 10);
      grid.rotateX(Math.PI / 2); 
      this.scene.add(grid);

      const axes = new AxesHelper();
      axes.material.depthTest = false;
      axes.renderOrder = 1;
      this.scene.add(axes);

      //Orbit Controls with TAKTing Turnpoint Object
      this.initializeCorporateOrbitControls(threeCanvas, this.scene);

        //Animation loop
        const animate = () => {

          // var delta = clock.getDelta();
          // this.controls.update(delta);
          // renderer.clear();
          requestAnimationFrame(animate);

          if (this.projection_type === 'minion') {
            let delta = Math.min( this.clock.getDelta(), 0.1 );
              if (this.is_fpv) {
                this.controls.maxPolarAngle = Math.PI;
                this.controls.minDistance = 1e-4;
                this.controls.maxDistance = 1e-4;
              } else {

                this.controls.maxPolarAngle = Math.PI / 2;
                this.controls.minDistance = 1;
                this.controls.maxDistance = 20;

              }

            if (this.collider) {
              this.collider.visible = this.fpv_params.displayCollider;
              let physicsSteps = this.fpv_params.physicsSteps;

              for ( let i = 0; i < physicsSteps; i ++ ) {
                this.updatePlayer((delta / physicsSteps) );
              }
            }

            // TODO: limit the camera movement based on the collider
            // raycast in direction of camera and move it if it's further than the closest point

            this.controls.update();
          }
          if (this.is_edit_geom) {
            this.resizeHandles();
          }
          this.checkSelectionUpdates();
          this.renderer.render(this.scene, this.camera);

          // Sync corporate Orbit Target position with actual turnpoint (controls.target)
          if (this.corporateOrbitTarget) {
            // this.corporateOrbitTarget.position.copy(this.controls.target);
            this.corporateOrbitTarget.position.lerp(this.controls.target, 0.5);
            // this.corporateOrbitTarget.position.set(
            //   this.controls.target.x, 
            //   this.controls.target.y, 
            //   this.controls.target.z
            // );
            if (this.model_is_loading) {
              this.corporateOrbitTarget.rotation.z -= 0.05
              this.corporateOrbitTarget.rotation.x += 0.01;
            }
          }
        };

        animate();

        this.mouse = new Vector2();
        this.raycaster = new Raycaster();
        this.raycaster.firstHitOnly = true;
        this.raycaster.params.Line.threshold = 0.1;
        this.raycaster.params.Points.threshold = 0.1;

        // console.log(this.raycaster);

      //Adjust the viewport to the size of the browser
      window.addEventListener("resize", () => {
        // (this.size.width = window.innerWidth), (this.size.height = window.innerHeight);
        this.size.width = content_el.clientWidth;
        this.size.height = content_el.clientHeight;

        this.camera.aspect = this.size.width / this.size.height;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(this.size.width, this.size.height);
      });
      content_el.addEventListener('resizetabs', () => {
        this.size.width = content_el.clientWidth;
        this.size.height = content_el.clientHeight;

        this.camera.aspect = this.size.width / this.size.height;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(this.size.width, this.size.height);
      });

      //register event listener for model

      content_el.addEventListener('mousedown', (event) => {
        this.modelMouseDown(event);
      });
      content_el.addEventListener('mouseup', (event) => {
        this.modelMouseUp(event);
      });
      content_el.addEventListener('mousemove', (event) => {
        this.modelMouseMove(event);
      });

      // register keyboard inputs on window
      window.addEventListener( 'keyup', (event) => {
         this.modelKeyUp(event);
      });
      window.addEventListener( 'keydown', (event) => {
         this.modelKeyDown(event);
      });
      window.addEventListener('mousedown', () => {
        this.window_mouse_down = true;
      });
      window.addEventListener('mouseup', () => {
        this.window_mouse_down = false;
      });

    },
    sceneLoadModels() {
      console.log('--- start scene load model');
      // this.ifcLoader = new IFCLoader();
      // Instantiate a loader
      let loader = new GLTFLoader();

      // Optional: Provide a DRACOLoader instance to decode compressed mesh data
      let dracoLoader = new DRACOLoader();
      // dracoLoader.setDecoderPath('http://localhost:8081/files/draco/');
      dracoLoader.setDecoderPath(process.env.VUE_APP_DRACO);
      loader.setDRACOLoader( dracoLoader );

      // //test load unstaged elements
      // let unstaged = [];
      // this.project.unstaged_elements.forEach(id => {
      //   unstaged.push(
      //     new Promise(resolve => {
      //       this.requestUObject({
      //         url: [
      //         {elements: id},
      //         {showWithEntitiesNormalized: ''}
      //         ],
      //         url_prefix: `/projects/${this.project_id}/projectstructure`,
      //         no_cache: true
      //       }).then(() => {
      //         resolve();
      //       })
      //     })
      //   );
      // });

      // Promise.all(unstaged).then(() => {
      // //end test load unstaged elements

      // initialize groups
      // group for all groups
      this.all_groups = new Group();
      this.all_groups.name = "all_groups";

      // transparent
      this.transparent_group = new Group();
      this.transparent_group.name = 'transparent_group';
      this.transparent_group.visible = false;
      this.all_groups.add(this.transparent_group);
      // plans
      this.plans_group = new Group();
      this.plans_group.name = 'plans_group';
      this.all_groups.add(this.plans_group);
      // taktareashapes
      this.taktareashapes_group = new Group();
      this.taktareashapes_group.name = 'taktareashapes_group';
      this.all_groups.add(this.taktareashapes_group);
      // points helper
      this.points_helper_group = new Group();
      this.points_helper_group.name = 'points_helper_group';
      this.all_groups.add(this.points_helper_group);
      // edges helper
      this.edges_helper_group = new Group();
      this.edges_helper_group.name = 'edges_helper_group';
      this.edges_helper_group.visible = false;
      this.all_groups.add(this.edges_helper_group);
      // stencil group
      // this.stencilPlaneGroup = new Group();
      // this.stencilPlaneGroup.name = "stencilPlaneGroup";
      // this.all_groups.add(this.stencilPlaneGroup);

      // edges collection groups
      ['element_selection', 'step_elements_edges', 'taktarea_elements_edges'].forEach(collection_type => {
        this[`${collection_type}_group`] = new Group();
        this[`${collection_type}_group`].name = `${collection_type}_group`;
        this.all_groups.add(this[`${collection_type}_group`]);
      });
      // // selection group
      // this.element_selection_group = new Group();
      // this.element_selection_group.name = 'element_selection_group';
      // this.all_groups.add(this.element_selection_group);

      // do for edges and normal representation
      let types = ['normal','edges'];
      types.forEach(type => {
        // group for all groups
        this[`all_${type}_groups`] = new Group();
        this[`all_${type}_groups`].name = `all_${type}_groups`;
        this.all_groups.add(this[`all_${type}_groups`]);

        // visible
        this[`visible_${type}_group`] = new Group();
        this[`visible_${type}_group`].name = `visible_${type}_group`;
        if (type === 'edges') {
          this[`visible_${type}_group`].visible = false;
        }
        this[`all_${type}_groups`].add(this[`visible_${type}_group`]);

        // selected
        this[`selected_${type}_group`] = new Group();
        this[`selected_${type}_group`].name = `selected_${type}_group`;
        if (type === 'edges') {
          this[`selected_${type}_group`].visible = false;
        }
        this[`all_${type}_groups`].add(this[`selected_${type}_group`]);

        // highlighted
        this[`highlighted_${type}_group`] = new Group();
        this[`highlighted_${type}_group`].name = `highlighted_${type}_group`;
        if (type === 'edges') {
          this[`highlighted_${type}_group`].visible = false;
        }
        this[`all_${type}_groups`].add(this[`highlighted_${type}_group`]);
      });

      // unstaged handling
      this.project.unstaged_elements.forEach(id => {
        this.initializeUnstagedElement(id);
      });
      // handle taktarashapes
      Object.keys(this.$store.state.Ultra.taktareashapes).forEach(id => {
        this.initializeTaktareashape(id);
      });
      // set visible initial -> initial invisible, visible when selecting process object
      // this.setCollectionObjects({collection_name: 'visible_taktareashapes', action: 'set', ids_by_target: {taktareashapes: Object.keys(this.$store.state.Ultra.taktareashapes)}});
      
      // plans handling
      // over all plans in ultrastore??
      let plan_promises = [];
      Object.keys(this.$store.state.Ultra.plans).forEach(id => {
        plan_promises.push(this.initializePlan(id));
      });
      Promise.all(plan_promises).then(() => { 
        console.log('end plan promise');    
      // glb handling
      let promises = [];
      // one glb for one site
      this.project.sites.forEach(id => {
        promises.push(this.loadDracoGLB({loader: loader, site_id: id}));
      });
      Promise.allSettled(promises).then(resps => {
        console.log('end site promises');
        // itereate over glbs
        resps.forEach(resp => {
          if (resp.status === 'fulfilled') {
            let meshes = [];
            let edges_meshes = [];
            resp.value.gltf.scene.children.forEach(child => {
              if (child.type === 'Mesh') {
              meshes = [child];
              } else if (child.type === 'Object3D') {
                edges_meshes = child.children;
              } else if (child.type === 'Group') {
                meshes = child.children;
              }
            });
            // if (resp.value.gltf.scene.children[1].type === 'Mesh') {
            //   meshes = [resp.value.gltf.scene.children[1]];
            // } else {
            //   meshes = resp.value.gltf.scene.children[1].children;
            // }
            // edges meshes
            console.log('--- start edges');
            edges_meshes.forEach(mesh => {
              // clipping
              mesh.material.clippingPlanes = this.clipping_planes;
              // save mesh names
              this.edges_mesh_names.push(`_edges_site_${resp.value.site_id}_${mesh.name}`);
              // edges
              // visible
              let visible_edges_mesh = mesh.clone();
              visible_edges_mesh.renderOrder = 50;
              visible_edges_mesh.name = `visible_edges_site_${resp.value.site_id}_${mesh.name}`;
              this.visible_edges_group.add(visible_edges_mesh);

              // colored edges for collection
              ['taktarea_elements', 'step_elements', 'highlighted', 'selected'].forEach((collection_type, index) => {
                let collection_edges_geometry = mesh.geometry.clone();
                collection_edges_geometry.setIndex(new BufferAttribute(Uint32Array.from([]), 1));
                let collection_edges_mesh = new THREE.LineSegments(collection_edges_geometry, this.edges_materials[collection_type]);
                collection_edges_mesh.renderOrder = (60 + (index*10));
                collection_edges_mesh.name = `${collection_type}_edges_site_${resp.value.site_id}_${mesh.name}`;
                this[`${collection_type}_edges_group`].add(collection_edges_mesh);
              })
              // //selected
              // let selected_edges_geometry = mesh.geometry.clone();
              // selected_edges_geometry.setIndex(new BufferAttribute(Uint32Array.from([]), 1));
              // let selected_edges_mesh = new THREE.LineSegments(selected_edges_geometry, this.highlight_material_edges);
              // selected_edges_mesh.renderOrder = 60;
              // selected_edges_mesh.name = `selected_edges_site_${resp.value.site_id}_${mesh.name}`;
              // this.selected_edges_group.add(selected_edges_mesh);
              // //highlighted
              // let highlighted_edges_geometry = mesh.geometry.clone();
              // highlighted_edges_geometry.setIndex(new BufferAttribute(Uint32Array.from([]), 1));
              // let highlighted_edges_mesh = new THREE.LineSegments(highlighted_edges_geometry, this.highlight_material_edges);
              // highlighted_edges_mesh.renderOrder = 70;
              // highlighted_edges_mesh.name = `highlighted_edges_site_${resp.value.site_id}_${mesh.name}`;
              // this.highlighted_edges_group.add(highlighted_edges_mesh);
              
              // element selection
              let element_selection_geometry = mesh.geometry.clone();
              element_selection_geometry.setIndex(new BufferAttribute(Uint32Array.from([]), 1));
              let element_selection_mesh = new THREE.LineSegments(element_selection_geometry, this.element_selection_material);
              element_selection_mesh.renderOrder = 80;
              element_selection_mesh.name = `element_selection_edges_site_${resp.value.site_id}_${mesh.name}`;
              this.element_selection_group.add(element_selection_mesh);

              // edges helper
              this.edges_helper_group.add(this.createEdgesHelperMesh(mesh.geometry, `helper_edges_site_${resp.value.site_id}_${mesh.name}`));

              // points test
              this.points_helper_group.add(this.createPointsHelperMesh(mesh.geometry));

            });
            console.log('--- end edges');
            // copy meshes
            console.log('--- start meshes');
            meshes.forEach((mesh, mesh_index) => {
              mesh.material.clippingPlanes = this.clipping_planes;
              // save mesh names
              this.mesh_names.push(`_normal_site_${resp.value.site_id}_${mesh.name}`);
              // transparent
              let transparent_geometry = mesh.geometry.clone();
              let transparent_mesh = new Mesh(transparent_geometry, this.transparent_material);
              transparent_mesh.renderOrder = 0;
              transparent_mesh.name = `transparent_normal_site_${resp.value.site_id}_${mesh.name}`;
              this.transparent_group.add(transparent_mesh);
              //visible mesh
              let visible_mesh = mesh.clone();
              visible_mesh.renderOrder = 10;
              visible_mesh.name = `visible_normal_site_${resp.value.site_id}_${mesh.name}`;
              this.visible_normal_group.add(visible_mesh);

              // testttt -----
              // let test_group = new Group();
              // test_group.name = `test_group${mesh_index}`;
              // this.all_groups.add(test_group);

              let visible_geometry = mesh.geometry.clone();
              // visible_geometry.computeVertexNormals();
              // // test
              // visible_geometry.computeFaceNormals();
              // visible_geometry.computeVertexNormals();

              // // test end



              // back
              let mat_back = mesh.material.clone();
              mat_back.depthWrite = false;
              mat_back.depthTest = false;
              mat_back.colorWrite = false;
              mat_back.stencilWrite = true;
              mat_back.stencilFunc = THREE.AlwaysStencilFunc;
              // mat_back.side = THREE.FrontSide;
              mat_back.side = THREE.BackSide; //bugfix some glbs?

              mat_back.stencilFail = THREE.IncrementStencilOp;
              mat_back.stencilZFail = THREE.IncrementStencilOp;
              mat_back.stencilZPass = THREE.IncrementStencilOp;

              // mat_back.stencilRef = mesh_index+1;
              // mat_back.stencilFail = THREE.ReplaceStencilOp;
              // mat_back.stencilZFail = THREE.ReplaceStencilOp;
              // mat_back.stencilZPass = THREE.ReplaceStencilOp;

              // mat_back.side = THREE.BackSide;
              // // mat_back.colorWrite = false;
              // mat_back.depthWrite = false;
              // mat_back.stencilWrite = true;
              // mat_back.stencilRef = mesh_index;
              // mat_back.stencilFunc = THREE.AlwaysStencilFunc;
              // mat_back.stencilZPass = THREE.ReplaceStencilOp;

              // // mat_back.stencilFunc = THREE.EqualStencilFunc;
              // // // mat_back.stencilFail = THREE.DecrementWrapStencilOp;
              // // // mat_back.stencilZFail = THREE.DecrementWrapStencilOp;
              // // // mat_back.stencilZPass = THREE.DecrementWrapStencilOp;
              // // // mat_back.stencilWriteMask = mesh_index.toString(16);
              
              mat_back.clippingPlanes = this.clipping_planes;
              let visible_geometry_mesh_back = new Mesh(visible_geometry, mat_back);
              visible_geometry_mesh_back.name = `back_${resp.value.site_id}_${mesh.name}`;
              visible_geometry_mesh_back.renderOrder = (mesh_index + 1) * 10;
              // this.stencilPlaneGroup.add(visible_geometry_mesh_back);
              this.stencilWriteMeshes.push(visible_geometry_mesh_back);


              // front 
              let mat_front = mesh.material.clone();
              mat_front = new THREE.MeshBasicMaterial();
              mat_front.depthWrite = false;
              mat_front.depthTest = false;
              mat_front.colorWrite = false;
              mat_front.stencilWrite = true;
              mat_front.stencilFunc = THREE.AlwaysStencilFunc;
              // mat_front.side = THREE.BackSide;
              mat_front.side = THREE.FrontSide; //bugfix some glbs?


              mat_front.stencilFail = THREE.DecrementStencilOp;
              mat_front.stencilZFail = THREE.DecrementStencilOp;
              mat_front.stencilZPass = THREE.DecrementStencilOp;

              // mat_front.stencilRef = mesh_index+1;
              // mat_front.stencilFail = THREE.ReplaceStencilOp;
              // mat_front.stencilZFail = THREE.ReplaceStencilOp;
              // mat_front.stencilZPass = THREE.ReplaceStencilOp;

              // mat_front.stencilFail = THREE.ZeroStencilOp;
              // mat_front.stencilZFail = THREE.ZeroStencilOp;
              // mat_front.stencilZPass = THREE.ZeroStencilOp;



              // mat_front.side = THREE.FrontSide;
              // mat_front.stencilWrite = true;
              // mat_front.stencilFail = THREE.IncrementWrapStencilOp;
              // mat_front.stencilZFail = THREE.IncrementWrapStencilOp;
              // mat_front.stencilZPass = THREE.IncrementWrapStencilOp;
              // // mat_front.stencilRef = 1;
              // mat_front.stencilWriteMask = mesh_index.toString(16);
              
              mat_front.clippingPlanes = this.clipping_planes;
              let visible_geometry_mesh_front = new Mesh(visible_geometry, mat_front);
              visible_geometry_mesh_front.name = `front_${resp.value.site_id}_${mesh.name}`;
              visible_geometry_mesh_front.renderOrder = (mesh_index + 1) * 10 + 1;
              // this.stencilPlaneGroup.add(visible_geometry_mesh_front);
              this.stencilWriteMeshes.push(visible_geometry_mesh_front);
              
              // testttt end -----

              //selected
              let selected_geometry = mesh.geometry.clone();
              selected_geometry.setIndex(new BufferAttribute(Uint32Array.from([]), 1));
              let selected_mesh = new Mesh(selected_geometry, this.highlight_material);
              selected_mesh.renderOrder = 20;
              selected_mesh.name = `selected_normal_site_${resp.value.site_id}_${mesh.name}`;
              this.selected_normal_group.add(selected_mesh);
              //highlighted
              let highlighted_geometry = mesh.geometry.clone();
              highlighted_geometry.setIndex(new BufferAttribute(Uint32Array.from([]), 1));
              let highlighted_mesh = new Mesh(highlighted_geometry, this.highlight_material);
              highlighted_mesh.renderOrder = 30;
              highlighted_mesh.name = `highlighted_normal_site_${resp.value.site_id}_${mesh.name}`;
              this.highlighted_normal_group.add(highlighted_mesh);

              // ----- do in edges iteration - better performance because less points ??? --------
              // // points test 
              // console.log('points start');
              // this.points_helper_group.add(this.createPointsHelperMesh(mesh.geometry));
              // console.log('points end');

              // render test points
              // let test_pts = new THREE.Points( mesh.geometry.clone(), this.points_material );
              // test_pts.renderOrder = 100;
              // this.points_helper_group.add(test_pts);
               // ----- do in edges iteration??? --------
            });
            console.log('--- end meshes');
          }
        });
        // console.log(this.stencilWriteMeshes);
        // let test_geom = {
        //   attributes: {
        //     position: {array: [0,0,0,1,0,1]},
        //     _takting_id: {array: [1,2]}
        //   }
        // };

        // this.createEdgesHelperMesh(test_geom);
        this.all_groups.rotateX( Math.PI / 2);
        this.scene.add(this.all_groups);
        this.setCollectionObjects({collection_name: 'visible_elements', action: 'set', ids_by_target: {elements: Object.keys(this.$store.state.ProjectStructure.project_elements)}});
        this.raycast_object = this.scene.getObjectByName('visible_normal_group');
        this.instantiateElements();
        this.model_is_loading = false;
        this.initializeClipping();

        // adjust camera to model
        this.camera.position.z = 30;
        this.camera.position.y = -30;
        this.camera.position.x = -30;
        this.zoomToVisible(this.camera);
        // stop loading rotation
        this.corporateOrbitTarget.rotation.z = 0.0;
        this.corporateOrbitTarget.rotation.x = 0.0;
        this.scene.getObjectByName('CorporateOrbitTarget').visible = false;

      console.log('--- end scene load model');
      })
      // .catch(() => {
      //   console.log('error occured loading glb');
      //   this.all_groups.rotateX( Math.PI / 2);
      //   this.scene.add(this.all_groups);
      //   console.log('heeeeereeee');
      //   this.setCollectionObjects({collection_name: 'visible_elements', action: 'set', ids_by_target: {elements: Object.keys(this.$store.state.ProjectStructure.project_elements)}});
      //   this.raycast_object = this.scene.getObjectByName('visible_normal_group');
      //   this.instantiateElements();
      //   this.model_is_loading = false;
      //   this.initializeClipping();

      // });
      // }); //from test unstaged geom
      }); //from plan promises
    },
    createPointsHelperMesh(geom) {
      // BVH Mesh creation
      let indices = [];
      let bvhGeometry = geom.clone();
      let verticesLength = bvhGeometry.attributes.position.count;
      for ( let i = 0, l = verticesLength; i < l; i ++ ) {
        indices.push( i, i, i );
      }
      bvhGeometry.setIndex( indices );
      let bvhMaterial = new THREE.MeshBasicMaterial( { color: 0xff0000 } );
      let bvhMesh = new THREE.Mesh( bvhGeometry, bvhMaterial );
      bvhMesh.geometry.computeBoundsTree();
      return bvhMesh;
    },
    createEdgesHelperMesh(geom, mesh_name) {
      // let all_vertices = [];
      let indices = [];
      let indices_temp = [0,1,2,2,1,3,4,5,6,6,5,7];
      let takting_ids = [];
      let arr = geom.attributes.position.array; //edges count = (arr.length / 3) -1
      let arr_len = ((arr.length / 3) - 1) * 24;
      let all_vertices = new Float32Array(arr_len);
      let vertices_offset = 0;
      
      // console.log(arr);
      for (let i = 3; i < arr.length; i+=6) {
        let vertices = this.createEdgeHelperVertices([arr[i-3],arr[i-2],arr[i-1]], [arr[i],arr[i+1],arr[i+2]], 0.1, 0.1);
        // vertices
        // let vertices_offset = all_vertices.length;
        for (let j = 0; j < vertices.length; j++) {
          all_vertices[vertices_offset+j] = vertices[j]; //array length error?!
        }
        vertices_offset += vertices.length;
        // takting_ids
        let offset_takting_id = takting_ids.length;
        for (let j = 0; j < 8; j++) {
          takting_ids[offset_takting_id + j] = geom.attributes._takting_id.array[i/3];
        }
        // indices
        let offset_ind_num = 0;
        if (indices.length !== 0) {
          offset_ind_num = indices[indices.length-1]+1;
        }
        let offset_ind_len = indices.length;
        for (let k = 0; k < indices_temp.length; k++) {
          indices[offset_ind_len+k] = indices_temp[k] + offset_ind_num;
        }
      }
      // console.log(all_vertices);
      let edges_helper_geometry = new THREE.BufferGeometry();
      edges_helper_geometry.setAttribute( 'position', new THREE.Float32BufferAttribute( all_vertices, 3 ) );
      edges_helper_geometry.setAttribute( '_takting_id', new THREE.Uint32BufferAttribute( takting_ids, 1 ) );

      edges_helper_geometry.setIndex(new BufferAttribute(Uint32Array.from(indices), 1));

      edges_helper_geometry.computeBoundsTree();
      // console.log(edges_helper_geometry);
      let edges_helper_mesh = new THREE.Mesh(edges_helper_geometry, this.highlight_material);
      edges_helper_mesh.name = mesh_name;
      return edges_helper_mesh;

    },
    createEdgeHelperVertices(center1, center2, width, height) {
      // Berechne den Verbindungsvektor zwischen den beiden Mittelpunkten
      let vectorX = center2[0] - center1[0];
      let vectorY = center2[1] - center1[1];
      let vectorZ = center2[2] - center1[2];
      
      // Berechne die Länge des Verbindungsvektors
      let length = Math.sqrt(
        Math.pow(vectorX, 2) +
        Math.pow(vectorY, 2) +
        Math.pow(vectorZ, 2)
      );
      // Normiere den Verbindungsvektor
      vectorX /= length;
      vectorY /= length;
      vectorZ /= length;
      
      // Berechne die Hälfte der Breite, Höhe und Länge des Quaders
      let halfWidth = width / 2;
      let halfHeight = height / 2;
      // let halfLength = length / 2;
      
      // Berechne die Normalen-Vektoren
      let normal_1_X;
      let normal_1_Y;
      let normal_1_Z;

      let normal_2_X;
      let normal_2_Y;
      let normal_2_Z;
      if (vectorX !== 0 || vectorY !== 0) {
        // zufällige normale zu Verbindungsvektor
        normal_1_X = -vectorY;
        normal_1_Y = vectorX;
        normal_1_Z = 0;
        // vektor der senkrecht zu normale und verbindungsvektor steht (Kreuzprodukt)
        normal_2_X =  (vectorY * normal_1_Z) - (vectorZ * normal_1_Y);
        normal_2_Y = (vectorZ * normal_1_X) - (vectorX * normal_1_Z);
        normal_2_Z = (vectorX * normal_1_Y) - (vectorY * normal_1_X);
      } else {
        // zufällige normale zu Verbindungsvektor
        normal_1_X = 0;
        normal_1_Y = 1;
        normal_1_Z = 0;
        // vektor der senkrecht zu normale und verbindungsvektor steht
        normal_2_X = 1;
        normal_2_Y = 0;
        normal_2_Z = 0;

      }

      // normale normieren auf länge 1
      let length_normal_1 = Math.sqrt(
        Math.pow(normal_1_X, 2) +
        Math.pow(normal_1_Y, 2) +
        Math.pow(normal_1_Z, 2)
      );
      let length_normal_2 = Math.sqrt(
        Math.pow(normal_2_X, 2) +
        Math.pow(normal_2_Y, 2) +
        Math.pow(normal_2_Z, 2)
      );
      normal_1_X /= length_normal_1;
      normal_1_Y /= length_normal_1;
      normal_1_Z /= length_normal_1;

      normal_2_X /= length_normal_2;
      normal_2_Y /= length_normal_2;
      normal_2_Z /= length_normal_2;

      // eckpunkte
      let points = [
          // 1 left
          center1[0] - normal_2_X * halfHeight - 0 * halfWidth,
          center1[1] - normal_2_Y * halfHeight - 0 * halfWidth,
          center1[2] - normal_2_Z * halfHeight - 0 * halfHeight,
          // 2 left
          center2[0] - normal_2_X * halfHeight - 0 * halfWidth,
          center2[1] - normal_2_Y * halfHeight - 0 * halfWidth,
          center2[2] - normal_2_Z * halfHeight - 0 * halfHeight,
          // 1 right
          center1[0] + normal_2_X * halfHeight + 0 * halfWidth,
          center1[1] + normal_2_Y * halfHeight + 0 * halfWidth,
          center1[2] + normal_2_Z * halfHeight + 0 * halfHeight,
          // 2 right
          center2[0] + normal_2_X * halfHeight + 0 * halfWidth,
          center2[1] + normal_2_Y * halfHeight + 0 * halfWidth,
          center2[2] + normal_2_Z * halfHeight + 0 * halfHeight,
          // 1 top
          center1[0] - 0 * halfHeight + normal_1_X * halfWidth,
          center1[1] - 0 * halfHeight + normal_1_Y * halfWidth,
          center1[2] - 0 * halfHeight + normal_1_Z * halfHeight,
          // 2 top
          center2[0] - 0 * halfHeight + normal_1_X * halfWidth,
          center2[1] - 0 * halfHeight + normal_1_Y * halfWidth,
          center2[2] - 0 * halfHeight + normal_1_Z * halfHeight,
          // 1 down
          center1[0] + 0 * halfHeight - normal_1_X * halfWidth,
          center1[1] + 0 * halfHeight - normal_1_Y * halfWidth,
          center1[2] + 0 * halfHeight - normal_1_Z * halfHeight,
          // 2 down
          center2[0] + 0 * halfHeight - normal_1_X * halfWidth,
          center2[1] + 0 * halfHeight - normal_1_Y * halfWidth,
          center2[2] + 0 * halfHeight - normal_1_Z * halfHeight,
        
      ];
      // Gib die Koordinaten der Eckpunkte des Quaders zurück
      return points;
    },
    initializeUnstagedElement(id) {
      let element = this.$store.state.Ultra.elements[id];
      let unstaged_geometry = this.createUnstagedGeometry(element.geometry);
      if (unstaged_geometry) {
        // transparent
        let transparent_mesh = this.createUnstagedGeometryMesh(unstaged_geometry, element, this.transparent_material, 'transparent');
        transparent_mesh.renderOrder = 0;
        this.transparent_group.add(transparent_mesh);
        // visible
        let visible_mesh = this.createUnstagedGeometryMesh(unstaged_geometry, element, this.shape_material, 'visible');
        visible_mesh.renderOrder = 10;
        this.visible_normal_group.add(visible_mesh);
        // selected
        let selected_mesh = this.createUnstagedGeometryMesh(unstaged_geometry, element, this.highlight_material, 'selected');
        selected_mesh.renderOrder = 20;
        selected_mesh.visible = false;
        this.selected_normal_group.add(selected_mesh);
        // highlighted
        let highlighted_mesh = this.createUnstagedGeometryMesh(unstaged_geometry, element, this.highlight_material, 'highlighted');
        highlighted_mesh.renderOrder = 30;
        highlighted_mesh.visible = false;
        this.highlighted_normal_group.add(highlighted_mesh);
      }
    },
    removeUnstagedElementMeshes(id)  {
      ['transparent', 'visible', 'selected', 'highlighted'].forEach(type => {
        this.removeObjectByName(`${type}_unstaged_${id}`, this[`${type}_group`]);
      });
    },
    async initializePlan(id) {
      return new Promise (resolve => {
        let plan = this.$store.state.Ultra.plans[id];
        this.createPlanMesh(plan).then(plan_mesh => {
          plan_mesh.renderOrder = 0;
          this.plans_group.add(plan_mesh);
          resolve();
        });
      })
    },
    removePlanMesh(id) {
      this.removeObjectByName(`plan_${id}`, this.plans_group);
    },
    initializeTaktareashape(id) {
      return new Promise(resolve => {
        let shape = this.$store.state.Ultra.taktareashapes[id];
        if (shape.geometry) { // if shape has geometry
          if (!shape.geometry.type) { //if not already parsed
            this.parseBlobGeometry({type: 'taktareashapes', id: id});
          }
          if (shape.geometry.points_x.length > 2) { // has drawn geometry -> improve !!!
            let shape_geometry = this.createUnstagedGeometry(shape.geometry);
            if (shape_geometry) {
              // shape geometry
              let shape_group = new Group();
              shape_group.visible = false;
              shape_group.name = `shape_group_${id}`;
              let shape_mesh = this.createUnstagedGeometryMesh(shape_geometry, shape, this.shape_material, 'shape');
              shape_mesh.renderOrder = 100;
              // shape_mesh.visible = false;
              // name is shape_unstaged_${id}
              shape_group.add(shape_mesh);
              // this.taktareashapes_group.add(shape_mesh);
  
              // edges geometry
  
              // text geometry
              let ta_name = this.$store.state.Ultra.taktareas[shape.parent.id].name;
              this.createTextMesh(ta_name).then(text_mesh => {
                // set height
                text_mesh.position.y = shape.geometry.offset[1] + shape.geometry.extrude_value + 0.01;
                // set horizontal position
                shape_mesh.geometry.computeBoundingBox();
                text_mesh.position.x = (shape_mesh.geometry.boundingBox.max.x + shape_mesh.geometry.boundingBox.min.x) * 0.5;
                text_mesh.position.z = (shape_mesh.geometry.boundingBox.max.z + shape_mesh.geometry.boundingBox.min.z) * 0.5;
    
                shape_group.add(text_mesh);
    
                // add group
                this.taktareashapes_group.add(shape_group);
                resolve();
              });
            } else {
              resolve();
            }
          } else {
            resolve();
          }
        } else {
          resolve();
        }
      });
    },
    removeUnstagedShapeMeshes(id)  {
      // this.removeObjectByName(`shape_unstaged_${id}`, this.taktareashapes_group);
      this.removeObjectByName(`shape_group_${id}`, this.taktareashapes_group);
    },
    modelMouseDown(event) {
      this.moved = false;
      // mouse shape selection
      if (!this.is_edit_geom && event.ctrlKey) {
        this.shapeSelectionMouseDown(event);
      }
    },
    modelMouseUp(event) {
      if (!this.moved) {
        if (!this.is_edit_geom) {
          // selects Geometry Object
          this.selectObject(event);
        } else if (this.is_edit_geom) {
          // edit_geom
          this.drawingMouseUp(event);
        }
      } 
      if (this.shape_selection_dragging) {
        this.shapeSelectionMouseUp(event);
      }
    },
    modelMouseMove(event) {
      this.moved = true;
      if (this.edit_geom_point_index !== -1) {
        this.drawingMouseMove(event);
      }
      else if (this.shape_selection_dragging) {
        this.shapeSelectionMouseMove(event);
      }
      else if (this.moving_point) {
        this.moveCursor(event);
      }
      else if (this.projection_type !== 'minion' && !this.window_mouse_down) {
        this.raycast(event);
      } 
    },
    modelKeyUp(event) {
      if (this.is_edit_geom) {
        this.drawingKeyUp(event);
      }
      this.controls.enablePan = true;
      this.controls.enableRotate = true;
      this.ctrl_key_down = false;
    },
    modelKeyDown(event) {
      if (event.ctrlKey) {
        this.controls.enablePan = false;
        this.controls.enableRotate = false;
        this.ctrl_key_down = true;
      }
    },
    loadDracoGLB(payload) {
      return new Promise((resolve, reject) => {
        payload.loader.load(
          // resource URL
          `${process.env.VUE_APP_IFC_GLB_URL}/${this.project_id}_${payload.site_id}.glb`,
          // called when the resource is loaded
          function ( gltf ) {
            resolve({site_id: payload.site_id, gltf: gltf});
            // gltf.animations; // Array<THREE.AnimationClip>
            // gltf.scene; // THREE.Group
            // gltf.scenes; // Array<THREE.Group>
            // gltf.cameras; // Array<THREE.Camera>
            // gltf.asset; // Object
          },
          // called while loading is progressing
          // xhr
          function (  ) {
          },
          // called when loading has errors
          // function ( error ) {
          function ( ) {
            reject();
          }
        );
      });
    },
    instantiateElements() {
      console.log('instantiate');
      let start = new Date();
      //reset elements
      this.elements_by_takting_id = {};
      this.scene.getObjectByName('visible_normal_group').traverse(el => {
        if (el.geometry && !el.unstaged) {
          el.geometry.computeBoundsTree();
          // el.geometry.index.array.forEach(ind => {
          let arr = el.geometry.index.array;
          for (let i = 0; i < arr.length; i++) {
            const ind = arr[i];
            let takting_id = el.geometry.attributes['_takting_id'].array[ind];
            let element = this.elements_by_takting_id[takting_id];
            if (element) {
              let subelement = element.find(subel => subel.mesh === el.name.substring(14));
              if (subelement) {
                // subelement.array.push(ind);
                subelement.array[subelement.array.length] = ind;
              } else {
                element.push({mesh: el.name.substring(14), array: [ind]});
              }
              // element.array.push(ind);
            } else {
              this.elements_by_takting_id[takting_id] = [{mesh: el.name.substring(14), array: [ind]}];
              // element = {mesh: el.name, array: [ind]};
            }
            // do index count;
            if (!this.index_count_by_takting_id[takting_id]) {
              this.index_count_by_takting_id[takting_id] = 0;
            }
            this.index_count_by_takting_id[takting_id]++;
          }
          // });
        }
      });
      // edges
      this.edges_elements_by_takting_id = {};
      this.scene.getObjectByName('visible_edges_group').traverse(el => {
        if (el.geometry && !el.unstaged) {
          // el.geometry.computeBoundsTree();
          // el.geometry.index.array.forEach(ind => {
          let arr = el.geometry.index.array;
          for (let i = 0; i < arr.length; i++) {
            const ind = arr[i];
            let takting_id = el.geometry.attributes['_takting_id'].array[ind];
            if (this.edges_elements_by_takting_id[takting_id]) {
              let subelement = this.edges_elements_by_takting_id[takting_id].find(subel => subel.mesh === el.name.substring(13));
              if (subelement) {
                // subelement.array.push(ind);
                subelement.array[subelement.array.length] = ind;
              } else {
                this.edges_elements_by_takting_id[takting_id].push({mesh: el.name.substring(13), array: [ind]});
              }
            } else {
              this.edges_elements_by_takting_id[takting_id] = [{mesh: el.name.substring(13), array: [ind]}];
            }
          // });
          }
        }
      });
      // edges helper // cost 200ms?
      this.edges_helper_elements_by_takting_id = {};
      this.scene.getObjectByName('edges_helper_group').traverse(el => {
        if (el.geometry && !el.unstaged) {
          // el.geometry.computeBoundsTree();
          // el.geometry.index.array.forEach(ind => {
          let arr = el.geometry.index.array;
          for (let i = 0; i < arr.length; i++) {
            const ind = arr[i];
            let takting_id = el.geometry.attributes['_takting_id'].array[ind];
            if (this.edges_helper_elements_by_takting_id[takting_id]) {
              let subelement = this.edges_helper_elements_by_takting_id[takting_id].find(subel => subel.mesh === el.name.substring(12));
              if (subelement) {
                // subelement.array.push(ind);
                subelement.array[subelement.array.length] = ind;
              } else {
                this.edges_helper_elements_by_takting_id[takting_id].push({mesh: el.name.substring(12), array: [ind]});
              }
            } else {
              this.edges_helper_elements_by_takting_id[takting_id] = [{mesh: el.name.substring(12), array: [ind]}];
            }
          // });
          }
        }
      });
      console.log(new Date().getTime() - start.getTime()); //1644

    },

    /**
    * Creates the orbit controls as well as the corporate orbit target / turnpoint object.
    * Adds a double-click event listener for the definition of the orbit target position.
    * Connects the position of the corporate orbit target with controls.target
    * @param {*} canvas 
    * @param {*} scene 
    */
    initializeCorporateOrbitControls(canvas, scene) {
      //Creates the orbit controls (to navigate the scene)
      this.controls = new OrbitControls(this.camera, canvas);
      this.controls.enableDamping = false;
      this.controls.enablePan = true;
      this.controls.enableRotate = true;
      this.controls.enableZoom = true;
      //Display turnpoint using corporate turnpoint object     
      //TAKT.ing colors for turnpoint sphere
      const colors = [
        "#000000",
        "#000000",
        "#424242",
        "#843C0C",
        "#942093",
        "#941651",
        "#FF2600",
        "#FF7E79",
        "#FF9300",
        "#FFFC00",
        "#8EFA00",
        "#00FA00",
        "#00FB92",
        "#00FDFF",
        "#0096FF",
        "#0432FF",
        "#000000",
        "#000000",
      ];
      const radius = 0.25;
      const segments = 32;
      this.corporateOrbitTarget = new Group();
      this.corporateOrbitTarget.name = "CorporateOrbitTarget";
      // Latitudes
      colors.forEach((color, index) => {
        const phi = (index / (colors.length - 1)) * Math.PI;
        const ringGeometry = new BufferGeometry().setFromPoints(
          Array.from({ length: segments + 1 }, (_, i) => {
            const theta = (i / segments) * 2 * Math.PI;
            const vertex = new THREE.Vector3();
            vertex.setFromSphericalCoords(radius, phi, theta);
            return vertex;
          })
        );
        const material = new THREE.LineBasicMaterial({ color: color });
        const ring = new THREE.LineLoop(ringGeometry, material);
        this.corporateOrbitTarget.add(ring);
      });
      // Longitudes
      // colors.forEach((color, index) => {
      //   const theta = (index / (colors.length - 1)) * 2 * Math.PI;
      //   const longitudeGeometry = new BufferGeometry().setFromPoints(
      //       Array.from({ length: segments + 1 }, (_, i) => {
      //           const phi = (i / segments) * Math.PI;
      //           const vertex = new THREE.Vector3();
      //           vertex.setFromSphericalCoords(radius, phi, theta);
      //           return vertex;
      //       })
      //   );
      //   const material = new LineBasicMaterial({ color: color });
      //   const longitude = new Line(longitudeGeometry, material);
      //   this.corporateOrbitTarget.add(longitude);
      // });
      scene.add(this.corporateOrbitTarget);
      // Set the initial position of the sphere to the current turnpoint of OrbitControls
      this.corporateOrbitTarget.position.copy(this.controls.target);



      // Click + Shift event listener for definition of the turnpoint
      this.renderer.domElement.addEventListener('click', (event) => {
        // console.log(event);
        if (event.shiftKey) {
          const canvasBounds = canvas.getBoundingClientRect();
          const mouseX = event.clientX - canvasBounds.left;
          const mouseY = event.clientY - canvasBounds.top;
          const mouse = new THREE.Vector2(
            (mouseX / canvas.offsetWidth) * 2 - 1,
            -(mouseY / canvas.offsetHeight) * 2 + 1
          );
          // console.log(`Fensterbreite: ${canvas.offsetWidth} und Fensterhöhe: ${canvas.offsetHeight}`);
          // const raycaster = new THREE.Raycaster();
          this.raycaster.setFromCamera(mouse, this.camera);
          this.raycaster.firstHitOnly = true;

          for (let obj of this.raycast_object.children) {
            try {
              this.raycaster.intersectObject(obj, true);
            } catch (error) {
              console.error("Error Object: ", obj);
            }
          }

          // const intersects = this.raycaster.intersectObjects(this.scene.children, true);
          const intersects = this.raycaster.intersectObjects(this.raycast_object.children, true);
          // console.log(intersects);

          if (intersects.length > 0) {
            const intersectionPoint = intersects[0].point;
            // Update the position of the corporateOrbitTarget and the target of OrbitControls
            this.corporateOrbitTarget.position.copy(intersectionPoint);
            this.controls.target.copy(intersectionPoint);
            this.controls.update();
            // console.log('controls updated');
          }
          // console.log('dblclick');
        }
      });
      // console.log('OrbitControls initialized');
    },
  },
};
